import { DesktopOutlined, UserOutlined, BellOutlined, DownOutlined, ArrowLeftOutlined } from '@ant-design/icons';
import type { MenuProps } from 'antd';
import { Layout, Menu, message } from 'antd';
import React, { useState, useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
// import { userLogout } from '../../service/auth/AuthService';
import { configApp } from '../../config/config';
import { deleteAccessToken, deleteUserAndPasswordLocal, getToken } from '../../helper/tokenHelper';

import './Initial.scss';

export default function Initial() {
	// const navigate = useNavigate();

	type MenuItem = Required<MenuProps>['items'][number];
	const { Header, Sider, Content, Footer } = Layout;
	const navigate = useNavigate();
	const [collapsed, setCollapsed] = useState(false);

	function getItem(
		label: React.ReactNode,
		key?: React.Key | null,
		icon?: React.ReactNode,
		children?: MenuItem[],
		type?: 'group',
	): MenuItem {
		return {
			key,
			icon,
			children,
			label,
			type,
		} as MenuItem;
	}

	const items: MenuItem[] = [
		getItem('Chức năng', 'sub1', <DesktopOutlined />, [getItem('Home', '/home'), getItem('Thống kê', '/assume')]),
	];

	const handleLogout = () => {
		localStorage.removeItem('userToken');
		localStorage.setItem('userToken', '');
		window.location.replace('/authenticate');
	};

	const handleChangePass = () => {
		navigate('/change-password');
	};

	const onClick: MenuProps['onClick'] = e => {
		navigate(e.key);
	};
	return (
		<Layout className="bg-layout">
			<Sider
				className="siderbar lg:hidden min-h-[900px]"
				collapsible
				collapsed={collapsed}
				onCollapse={value => setCollapsed(value)}
			>
				<div className="logo h-10 text-white flex items-center ml-5 h-[64px]"></div>
				<Menu theme="dark" defaultSelectedKeys={['1']} mode="inline" items={items} onClick={onClick} />
			</Sider>
			<Layout className="site-layout">
				<Header className="header flex items-center w-full justify-between">
					<div className="flex items-center text-white ">
						<ArrowLeftOutlined
							onClick={() => {
								navigate(-1);
							}}
						/>
						<div className="flex items-center ml-10">
							{/* <UserOutlined
								onClick={() => {
									navigate('/home');
								}}
								className="mr-5"
							/> */}
							<p className="text-white mb-0 title">Web Đặt Cơm</p>
						</div>
					</div>
					<div className="flex items-center text-white mr-5 ">
						<BellOutlined className=" mr-5" />
						<div className="relative button-down p-5 flex justify-center items-center">
							<DownOutlined className="text-white" />
							<ul className="list text-white bg-white absolute w-[7rem] top-[3rem] mb-0 shadow-gray-400 rounded-sm">
								<li
									className=" text-[black] text-center
							 leading-10 list_item shadow-lg"
									onClick={handleLogout}
								>
									Log out
								</li>
								{/* <li
									className="text-[black] text-center leading-10 list_item  shadow-lg"
									// onClick={handleChangePass}
								>
									Change Password
								</li> */}
							</ul>
						</div>
					</div>
				</Header>
				<Content className="mx-4 my-0">
					<Outlet />
				</Content>
				<Footer className="text-center"></Footer>
			</Layout>
		</Layout>
	);
}
